
<template>
  <v-form ref="form" v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container>
      <v-row dense>
        <v-col cols="12" md="3" offset-md="1">
          <v-select
            :items="getCodeDateUtil('lang')"
            label="語言別"
            dense
            v-model="interpreterCase.language"
            :rules="requiredRules"
            :readonly="isNotBlankUtil(queryObject.serviceLanguage) || copyFlag"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            :items="people"
            label="預計人數"
            dense
            v-model="interpreterCase.people"
            :rules="requiredRules"
            :readonly="copyFlag"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            :items="getCommonArrayUtil('needHours')"
            label="預計時數"
            dense
            v-model="interpreterCase.estimatedHours"
            :rules="requiredRules"
            :readonly="copyFlag"
          ></v-select>
        </v-col>

        <v-col cols="12" md="3" offset-md="1">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :disabled="isNotBlankUtil(searchCase.searchDate) || copyFlag"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="interpreterCase.serviceDate"
                label="需求時間"
                :readonly="isNotBlankUtil(searchCase.searchDate)"
                v-on="on"
                :rules="requiredRules"
              ></v-text-field>
            </template>
            <v-date-picker
              :min="getDateFormat(new Date().getTime(), 'yyyy-MM-dd', true)"
              v-model="interpreterCase.serviceDate"
              @input="menu = false"
              locale="zh-cn"
              style="font-family:Microsoft JhengHei;"
              color="red"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            :items="getCommonArrayUtil('timeSolt')"
            label="時段"
            @change="timeSoltObject"
            :readonly="isNotBlankUtil(searchCase.searchTime) || copyFlag"
            v-model="interpreterCase.serviceSession"
            :rules="requiredRules"
          ></v-select>
        </v-col>

        <v-col cols="12" md="3">
          <v-select
            :items="serviceStartTimeArray"
            label="預計服務開始時間"
            v-model="interpreterCase.estimatedServiceStartTime"
            :rules="requiredRules"
            :readonly="copyFlag"
          />
        </v-col>
        <v-col cols="12" md="1">
          <div class="text-center">
            <v-btn color="red" dark @click="dialogNote = !dialogNote;noteItem = notes.note1;">注意事項</v-btn>
            <!-- <v-bottom-sheet v-model="sheetFlag1" inset>
              <template v-slot:activator="{ on }">
                <v-btn color="red" dark v-on="on" @click.prevent="changeFlag">注意事項</v-btn>
              </template>
              <v-sheet class="text-center" height style="font-family:Microsoft JhengHei;">
                <div>
                  <br />
                  <h3>依照地方政府辦理非營利組織陪同外國人接受詢問作業要點規定：</h3>
                  <br />（1）以通知通譯人員到場之約定時間或實際開始通譯時間起至實際結束通譯時間。
                  <br />（2）第三小時起，未滿三十分鐘者，以半小時計；三十分鐘以上未滿一小時者，以一小時計。
                  <br />（3）每次通譯時間以四小時為限。但經通譯人員同意者，可延長至八小時。
                  <br />（4）連續通譯四小時，經通譯人員同意者，得暫停翻譯並休息，休息時間不計入時數。但案件有連續性或緊急性者，得另行調配其休息時間。
                  <br />
                </div>
              </v-sheet>
            </v-bottom-sheet>-->
          </div>
        </v-col>

        <v-col cols="12" md="3" offset-md="1">
          <v-select
            :items="districtArray1"
            item-text="name"
            item-value="id"
            @change="districtObjectUtil(interpreterCase.serviceCity)"
            label="服務地點"
            v-model="interpreterCase.serviceCity"
            :readonly="isNotBlankUtil(queryObject.serviceCity) || copyFlag"
            :rules="requiredRules"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            :items="districtArray2"
            item-text="name"
            item-value="id"
            v-model="interpreterCase.serviceDistrict"
            :readonly="isNotBlankUtil(searchCase.searchDistrict) || copyFlag"
            :rules="requiredRules"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            label="服務地址"
            v-model="interpreterCase.serviceAddress"
            :rules="requiredRules"
            :readonly="copyFlag"
          />
        </v-col>
        <v-col cols="12" md="4" offset-md="1">
          <v-select
            :items="getCodeDateUtil('serveType')"
            label="案件類型"
            v-model="interpreterCase.caseType"
            :readonly="isNotBlankUtil(queryObject.serviceType) || copyFlag"
            :rules="requiredRules"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3" offset-md="2">
          <v-select
            :items="getCommonArrayUtil('payMethod')"
            label="計費方式"
            v-model="interpreterCase.feeType"
            :rules="requiredRules"
            :readonly="copyFlag"
          ></v-select>
        </v-col>
        <!-- <v-col cols="12" md="3" offset-md="1">
          <v-text-field label="費用給付" v-mask="numberMask" v-model="numberMaskTest" />
        </v-col>
        <v-col cols="12" md="3">
          <v-select :items="getCommonArrayUtil('payUnit')" label="計算單位"></v-select>
        </v-col>-->
        <v-col cols="12" md="1">
          <div class="text-center">
            <v-btn color="red" dark @click="dialogNote = !dialogNote;noteItem = notes.note2;">注意事項</v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="10" offset-md="1">
          <v-textarea
            label="案件敘述"
            dense
            v-model="interpreterCase.caseNote"
            :rules="requiredRules"
            :readonly="copyFlag"
          />
        </v-col>

        <v-col cols="12" md="3" offset-md="1">
          <v-datetime-picker
            label="通譯回覆期限"
            v-model="interpreterCase.responseDueDate"
            v-bind:datePickerProps="datePickerProps"
            v-bind:timePickerProps="timePickerProps"
            v-bind:textFieldProps="textFieldProps"
          >
            <template slot="actions" slot-scope="{ parent }">
                <v-btn color="grey lighten-3" style="color:black;" @click.native="parent.clearHandler">取消</v-btn>
                <v-btn color="red" style="color:white;" class="ma-2" @click="parent.okHandler();checkDueDatePicker(parent)">確定</v-btn>

            </template>

            <!-- <v-icon slot="dateIcon" v-bind:color={}>mdi-delete</v-icon> -->
          </v-datetime-picker>

          <!-- <vuetify-datetime 
            v-model="interpreterCase.responseDueDate"
            label="通譯回覆期限"
            v-bind:options="options"
            v-on:click="shit(this)"
          />-->
        </v-col>
        <v-col cols="12" md="10"></v-col>
        <v-col cols="12" md="4" offset-md="1">
          <v-text-field
            label="聯絡人"
            dense
            v-model="interpreterCase.contactName"
            :rules="requiredRules"
            :readonly="copyFlag"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="聯絡電話"
            dense
            v-model="interpreterCase.contactHomeTel"
            :rules="requiredRules"
            :readonly="copyFlag"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="行動電話"
            dense
            v-model="interpreterCase.contactMobileTel"
            :rules="requiredRules"
            :readonly="copyFlag"
          />
        </v-col>
        <!-- <v-col cols="12" md="3"></v-col>
        <v-col cols="12" md="3" offset-md="1">
          <v-text-field label="交通費" v-mask="numberMask" />
        </v-col>-->

        <v-col cols="12" md="8"></v-col>

        <v-col
          cols="12"
          md="4"
          offset-md="1"
          class="text-center"
          v-for="(item,i) in items"
          v-bind:key="i"
        >
          <v-card>
            <v-card-title>
              <h3>{{ item.name }}</h3>
              <h4>（{{item.gender=='M'?'男':'女'}}） 案件數：{{item.caseCount}}</h4>
              <v-spacer />
              <v-rating
                readonly
                v-model="item.score"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$ratingFull"
                half-increments
                hover
              ></v-rating>
              <v-spacer />
              <v-btn @click="dialog = !dialog;targetItem = item;" class="ma-1">
                <v-icon>search</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" md="10" offset-md="1" class="text-center">
          <v-btn color="grey lighten-3" style="color:black;" @click.prevent="$router.go(-1)">取消</v-btn>
          <v-btn color="red" style="color:white;" class="ma-2" @click.prevent="submitObject" :disabled="(!valid)" >確定</v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="800px" v-if="dialog">
      <InterpreterDetail :memberItem="targetItem" v-on:childDialog="parentDialog"></InterpreterDetail>
    </v-dialog>

    <v-dialog v-model="dialogNote" width="800px">
      <NoteComponents :noteItem="noteItem" v-on:childDialog="parentDialog"></NoteComponents>
    </v-dialog>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import InterpreterDetail from "../Common/InterpreterDetail";
import NoteComponents from "../Common/NoteComponents";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    InterpreterDetail,
    NoteComponents
  },
  computed: {
    ...mapGetters({
      getUserId: ["getUserId"],
      getTargetId: ["getTargetId"],
      getIcArray: ["getIcArray"],
      getSearchCase: ["getSearchCase"],
      getQueryObject: ["getQueryObject"],
      idbServerUrl: ["getIdbServerUrl"],
      getInterpreterId: ["getInterpreterId"],
      getTargetCaseId: ["getTargetCaseId"]
    })
  },
  directives: {
    mask
  },
  data() {
    return {
      requiredRules: [v => !!v || ""],
      copyFlag: false,
      date: new Date().toISOString().substr(0, 10),
      // date: null,
      color: "red",
      menu: false,
      dialog: false,
      dialogNote: false,
      valid: false,
      sheetFlag1: false,
      sheetFlag2: false,
      timeMask: "##:##",
      numberMask: "#######",
      numberMaskTest: "2252",
      moneyTest: 1232222.45,
      selectOption: ["A", "B"],
      startTimeHours: [],
      timeSoltArrayMap: this.getCommonArrayUtil("timeSoltArrayMap"),
      timeSolt: "1",
      targetItem: {},
      items: [],
      value: new Date().toISOString().substr(0, 10),
      label: "Date",
      datePickerProps: {
        locale: "zh-tw",
        color: "red",
        min: this.getDateFormat(new Date().getTime(), "yyyy-MM-dd", true)
      },
      timePickerProps: {
        format: "24hr",
        color: "red"
      },
      textFieldProps: {
        rules: [v => !!v || "此欄位是必填"]
      },

      options: {
        tabDateTitle: "日期",
        tabTimeTitle: "時間",
        locale: "zh-tw",
        format: "YYYY-MM-DD",
        backgroundColor: "red",
        closeOnDateClick: false,
        useSeconds: false,
        clearable: true,
        closeOnContentClick: true
      },
      noteItem: {},
      notes: {
        note1: {
          title: "依照地方政府辦理非營利組織陪同外國人接受詢問作業要點規定",
          contentArray: [
            "以通知通譯人員到場之約定時間或實際開始通譯時間起至實際結束通譯時間。",
            "第三小時起，未滿三十分鐘者，以半小時計；三十分鐘以上未滿一小時者，以一小時計。",
            "每次通譯時間以四小時為限。但經通譯人員同意者，可延長至八小時。",
            "連續通譯四小時，經通譯人員同意者，得暫停翻譯並休息，休息時間不計入時數。但案件有連續性或緊急性者，得另行調配其休息時間。"
          ]
        },
        note2: {
          title: "依照地方政府辦理非營利組織陪同外國人接受詢問作業要點規定",
          contentArray: [
            "日間通譯費用：每案次前二小時內補助六百元，第三小時起，每一小時補助三百元。",
            "夜間通譯費用：執行通譯時間為夜間時段（二十二時至翌日六時）者，每案次前二小時內補助一千二百元，第三小時起，每一小時補助六百元。",
            "每案次前二小時跨日間及夜間時段，採夜間通譯費用計算。第三小時起若跨日間及夜間時段，則該跨越時段之費用，以夜間通譯費用計算，其餘依各時段通譯費用計算。",
            "通譯人員之交通費用，比照第六點陪同人員之規定覈實補助。"
          ]
        }
      },
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      searchCase: {},
      queryObject: {},
      interpreterCase: this.getModel("interpreterCase"),
      serviceStartTimeArray: [],
      caseDetail: [],
      people: []
    };
  },
  methods: {
    ...mapActions([
      "updateIcArray",
      "updateSearchCase",
      "updateTargetCaseId",
      "updateQueryObject"
    ]),
    checkDueDatePicker(parent) {
      if (
        this.getDateFormat(
          this.interpreterCase.responseDueDate.getTime(),
          "yyyy-MM-dd",
          true
        ) == this.getDateFormat(new Date().getTime(), "yyyy-MM-dd", true) &&
        this.getDateFormat(
          this.interpreterCase.responseDueDate.getTime(),
          "HH:mm",
          true
        ) <= this.getDateFormat(new Date().getTime(), "HH:mm", true)
      ) {
        parent.clearHandler();
        alert("通譯回覆期限時間已超過，請重新設定!");
      }
    },
    timeSoltObject() {
      var vm = this;
      if (vm.isNotBlankUtil(vm.interpreterCase.serviceSession))
        vm.serviceStartTimeArray = vm.getCommonArrayUtil("timeSolt")[
          vm.interpreterCase.serviceSession - 1
        ].childArray;
    },
    parentDialog() {
      this.dialog = false;
      this.dialogNote = false;
    },
    submitObject() {
      var vm = this;

      vm.items.forEach(function(element) {
        var detail = vm.getModel("interpreterCaseDetail");
        detail.memberId = element.uuid;
        detail.memberName = element.name;
        detail.memberDeptId  = element.mainDeptId;
        detail.status = "I00";
        vm.caseDetail.push(detail);
      });
      console.log(
        JSON.parse(this.$localStorage.get("userProfileStr")).memberAccount
          .mainDeptName
      );
      let userProfile = JSON.parse(this.$localStorage.get("userProfileStr"));
      vm.interpreterCase.deptId = userProfile.memberAccount.mainDeptId;
      vm.interpreterCase.deptName = userProfile.memberAccount.mainDeptName;
      vm.interpreterCase.status = "C01";
      var data = {
        ic: vm.interpreterCase,
        detailList: vm.caseDetail
      };

      console.log(JSON.stringify(data));

      vm.submitConfirmUtil().then(function(result) {
        if (result == true) {
          vm.updateIcArray([]);
          vm.updateSearchCase({});
          vm.updateQueryObject({});

          vm.axios
            .post(vm.idbServerUrl + "idb/interpreterCase", data, {
              headers: {
                "Content-Type": "application/json",
                Authorization: vm.$localStorage.get("idb_login_token")
              }
            })
            .then(function(response) {
              // console.log("response " + JSON.stringify(response));
              vm.successSwalUtil();
              console.log("SUCCESS!!!!!!! " + response);

              vm.$router.push({
                path: "/caseList"
              });
            })
            .catch(function(error) {
              vm.handErrorUtil(error);
              console.log("!!!! " + error);
            });
        } else if (result == "cancel") {
          console.log(" CANCEL!!!!!!!!!!!! ");
        }
      });
    },
    changeFlag() {
      var vm = this;

      vm.sheetFlag1 = !vm.sheetFlag1;

      // setTimeout(function() {
      //   console.log("2!!!!!!!!!!!!!!");
      //   vm.sheetFlag1 = !vm.sheetFlag1;
      // }, 1000);
    },
    showAlert() {
      setTimeout(function() {
        try {
          this.submitConfirmUtil();
        } catch (err) {
          console.log("X");
        }
      }, 10000);

      // console.log("SSS  " + this.submitConfirmUtil());
    },
    topObject() {
      document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
    }
  },
  mounted: function() {
    var vm = this;
    vm.timeSoltObject();
    console.log("vm.getQueryObject " + JSON.stringify(vm.getQueryObject));
    if (vm.getQueryObject != null) {
      vm.queryObject = JSON.parse(JSON.stringify(vm.getQueryObject));
      vm.interpreterCase.language = vm.queryObject.serviceLanguage;
      if (vm.isNotBlankUtil(vm.queryObject.serviceCity)) {
        vm.interpreterCase.serviceCity = vm.queryObject.serviceCity;
      }
      vm.interpreterCase.caseType = vm.queryObject.serviceType;
    }
    if (vm.getSearchCase != null) {
      vm.searchCase = JSON.parse(JSON.stringify(vm.getSearchCase));
      vm.interpreterCase.serviceDate = vm.searchCase.searchDate;
      vm.interpreterCase.serviceSession = vm.searchCase.searchTime;
      vm.interpreterCase.serviceDistrict = vm.searchCase.searchDistrict;
      if (vm.isNotBlankUtil(vm.interpreterCase.serviceSession))
        vm.serviceStartTimeArray = vm.getCommonArrayUtil("timeSolt")[
          vm.interpreterCase.serviceSession - 1
        ].childArray;
    }

    vm.districtObjectUtil(vm.queryObject.serviceCity);

    // if (vm.getSearchCase != null) {
    //   vm.searchCase = JSON.parse(JSON.stringify(vm.getSearchCase));
    //   vm.districtObjectUtil(vm.searchCase.searchCity);
    // }
    vm.items = vm.getIcArray;
    for (let i = 1; i <= vm.items.length; i++) {
      vm.people.push(i);
    }

    //複製案件
    if (vm.getTargetCaseId != null && vm.getTargetCaseId != "") {
      vm.copyFlag = true;
      vm.searchCase = {};
      vm.queryObject = {};
      vm.updateIcArray([]);
      vm.updateQueryObject(vm.queryObject);
      vm.updateSearchCase(vm.searchCase);

      vm.axios
        .get(vm.idbServerUrl + "idb/interpreterCase/" + vm.getTargetCaseId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          vm.interpreterCase = response.data;
          vm.interpreterCase.caseId = null;
          vm.interpreterCase.checkInDatetime = null;
          vm.interpreterCase.checkInLantitude = null;
          vm.interpreterCase.checkInLongtitude = null;
          vm.interpreterCase.checkInPosition = null;
          vm.interpreterCase.startServiceDatetime = null;
          vm.interpreterCase.finishServiceDatetime = null;
          vm.interpreterCase.commentToDept = null;
          vm.interpreterCase.isCommentToInterpreter = null;
          vm.interpreterCase.serviceDate = vm.getDateFormat(
            vm.interpreterCase.serviceDate,
            "yyyy-MM-dd",
            true
          );
          if (vm.isNotBlankUtil(vm.interpreterCase.serviceSession))
            vm.serviceStartTimeArray = vm.getCommonArrayUtil("timeSolt")[
              vm.interpreterCase.serviceSession - 1
            ].childArray;

          vm.districtObjectUtil(vm.interpreterCase.serviceCity);

          var queryObjectStr = JSON.stringify({});
          var queryPagerStr = JSON.stringify({
            pageSize: -1,
            currentPage: 1
          });
          let memberUuidArray = [];
          vm.interpreterCase.interpreterCaseDetails.forEach(detail => {
            //過濾通譯人才案件取消
            if (detail.status != "I05")
              memberUuidArray.push({
                propertyName: "uuid",
                value: detail.memberId
              });
          });

          var criterionStr = JSON.stringify({
            in: memberUuidArray
          });
          vm.interpreterCase.interpreterCaseDetails = [];
          vm.axios
            .get(
              vm.idbServerUrl +
                "idb/member/memberAccount?queryString=" +
                encodeURIComponent(queryObjectStr) +
                "&queryPager=" +
                encodeURIComponent(queryPagerStr) +
                "&criterion=" +
                encodeURIComponent(criterionStr),
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: vm.$localStorage.get("idb_login_token")
                }
              }
            )
            .then(function(response) {
              var dataResponse = JSON.stringify(response.data.resultList);
              vm.items = response.data.resultList;
              vm.people = [];
              for (let i = 1; i <= vm.items.length; i++) {
                vm.people.push(i);
              }
              vm.interpreterCase.people = 1;
              console.log(dataResponse);
            })
            .catch(function(error) {
              vm.handErrorUtil(error);
              console.log(error);
            });

          vm.updateTargetCaseId("");
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log(error);
        });
    }
    vm.$refs.form.validate();
  }
};
</script>
